import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import BiologicalAgeCheckLanding from "./landing-pages/BiologicalAgeCheckLanding";
import BiologicalAge from "./biological-age/BiologicalAge";
import { CookieConsent } from "./CookieConsent";
import Home from "./home/Home";
import Insurers from "./insurers/Insurers";
import LeagueInvite from "./league-invite/LeagueInvite";
import {
  NavigationPath,
  NavigationPathUtils,
} from "./navigation/NavigationCommon";
import analytics, { generalConsentCookie } from "./services/analytics";
import SocialShare from "./social-share/SocialShare";
import Team from "./team/Team";
import BioageLiveLanding from "./landing-pages/BioageLiveLanding";
import ActivityRejuvenatesLanding from "./landing-pages/ActivityRejuvenatesLanding";
import ActivityRejuvenatesByLanding from "./landing-pages/ActivityRejuvenatesByLanding";
import DeleteAccountPage from "./delete-account/DeleteAccountPage";

function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export const App: React.FC = () => {
  const pathname = window.location.pathname;

  const [cookies, setCookie] = useCookies([generalConsentCookie]);
  const hasCookieConsent = generalConsentCookie in cookies;
  const needsCookieConsent = NavigationPathUtils.needsCookieConsent(pathname);

  return (
    <CookieConsent
      visible={!hasCookieConsent && needsCookieConsent}
      onAccept={() => {
        setCookie(generalConsentCookie, Date.now());
        analytics.enable();
        analytics.logPageView("home");
      }}
    >
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path={NavigationPath.socialShare} element={<SocialShare />} />
          <Route
            path={NavigationPath.leagueInvite}
            element={<LeagueInvite />}
          />
          <Route path={NavigationPath.home} element={<Home />} />
          <Route
            path={NavigationPath.biologicalAge}
            element={<BiologicalAge />}
          />
          <Route path={NavigationPath.insurers} element={<Insurers />} />
          <Route path={NavigationPath.team} element={<Team />} />
          <Route
            path={NavigationPath.biologicalAgeCheckLanding}
            element={<BiologicalAgeCheckLanding />}
          />
          <Route
            path={NavigationPath.bioageLiveLanding}
            element={<BioageLiveLanding />}
          />
          <Route
            path={NavigationPath.activityRejuvenatesLanding}
            element={<ActivityRejuvenatesLanding />}
          />
          <Route
            path={NavigationPath.activityRejuvenatesByLanding}
            element={<ActivityRejuvenatesByLanding />}
          />
          <Route
            path={NavigationPath.deleteAccount}
            element={<DeleteAccountPage />}
          />
          <Route path="*" element={<Navigate to={NavigationPath.home} />} />
        </Routes>
      </Router>
    </CookieConsent>
  );
};
